export interface PaginationModel {
  page: number;
  limit: number;
  totalPages: number;
  totalRecords: number;
  isResetPage?: boolean;
}

export enum PaginationHeader {
  Page = 'X-Page',
  Limit = 'X-Limit',
  TotalPages = 'X-Total-Pages',
  TotalRecords = 'X-Total-Records',
}

export function serializePaginationFromHeader(headers: {
  [key: string]: number;
}): PaginationModel {
  const { Page, Limit, TotalPages, TotalRecords } = PaginationHeader;

  const page = Number(headers[Page.toLowerCase()]);
  const limit = Number(headers[Limit.toLowerCase()]);
  const totalPages = Number(headers[TotalPages.toLowerCase()]);
  const totalRecords = Number(headers[TotalRecords.toLowerCase()]);

  return {
    page,
    limit,
    totalPages,
    totalRecords,
  };
}
